import type { Task } from "@common/types";
import type { LogHarvestResponse } from "@common/types/Harvest";
import type { Dayjs } from "dayjs";
import { createContext } from "react";

export type HarvestSheetTask = Pick<
  Task,
  "id" | "gardenId" | "cropId" | "gardenCropId" | "startDate" | "endDate"
>;

export type OpenHarvestSheetParams = {
  task: HarvestSheetTask;
  date: Dayjs;
  onSuccess?: (response: LogHarvestResponse) => void;
};

type HarvestSheetContextType = {
  openHarvestSheet: (params: OpenHarvestSheetParams) => void;
};

export const HarvestSheetContext = createContext<HarvestSheetContextType | null>(null);
